module.exports = {
  apiRootURL: "https://krj8fdfdy9.execute-api.eu-central-1.amazonaws.com/dev",
  apiURLs: {
    endpoint_get_index_content: "/v1/index/content",
    endpoint_get_slideshows: "/v1/get/slideshows",
    endpoint_product_filter: "/v1/product/filter",
    endpoint_get_product_details: "/v1/get/product/details",
    endpoint_save_order: "/v1/checkout/add",
  },
  rootUrl: "rootUrl",
  appVersion: "1.0",
  apiUrls: {},
  company_name: "Luminit",
  facebook_page_url: "https://www.facebook.com/luminitde",
  instagram_page_url: "https://www.instagram.com/luminit.de",
  main_paige_title: "Luminit.de",
  menu: [
    { title: "Shop", to: "/shop", slug: "shop" },
    { title: "Über uns", to: "/about", slug: "about" },
    { title: "Kontakt", to: "/contact", slug: "contact" }
  ],
};
